import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import TicketLinks from './TicketLinks.js';
import TicketStatus from './TicketStatus';
import TicketInfo from './TicketInfo'
import './TicketBasicInformation.scss'

const TicketBasicInformation = (props) => {    

    const lang = useSelector(state => state.layout.lang)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <Fragment>
            <TicketLinks ticket={props.ticket} lang={lang} />
            <TicketStatus ticket={props.ticket} lang={lang} />
            <TicketInfo ticket={props.ticket} lang={lang}/>
        </Fragment>
    );
}

TicketBasicInformation.propTypes = {
    ticket: PropTypes.object
}
TicketBasicInformation.whyDidYouRender = false;

export default TicketBasicInformation